import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DataTablesModule } from 'angular-datatables';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { PortletModule } from '../partials/content/general/portlet/portlet.module';
// import { NgxOrgChartModule } from 'ngx-org-chart';
import { AccumulationChartModule, ChartModule } from '@syncfusion/ej2-angular-charts';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CarouselModule } from 'primeng/carousel';
// import { TicketdetailsComponent } from './all-shared/ticketdetails/ticketdetails.component';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PortletModule, //ktportlet module
    TranslateModule.forChild(),
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule.forChild([]), 
    // NgxOrgChartModule,                        //module for chart
		ChartModule,//module for chart
	  AccumulationChartModule,//module for chart
    NgMultiSelectDropDownModule,      //module for multiselect dropdown
    ToastrModule.forRoot(),
    HttpClientModule,
    MatRadioModule,
    PerfectScrollbarModule,
    MatIconModule,
    CarouselModule,
    ImageCropperModule,
  ],
  exports: [
    CommonModule,
    PortletModule, //ktportlet module
    TranslateModule,
    DataTablesModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    RouterModule, 
    // NgxOrgChartModule,                        //module for chart
		ChartModule,//module for chart
	  AccumulationChartModule,//module for chart
    NgMultiSelectDropDownModule,      //module for multiselect dropdown
    ToastrModule,   
    MatRadioModule,
    CarouselModule,
    ImageCropperModule
  ],
  providers:[
    NgbActiveModal,
  ],
  // entryComponents: [TicketdetailsComponent],      // imported for new design change //sowmiya
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class SharedModule { }